// _log.js
class VisitLog {
	constructor({ storageKey = 'pjax.visit.log', autosave = true } = {}) {
		this.backDelete = false; //バックでページを戻った時に記録を消す
		
		this.storageKey = storageKey;
		this.autosave 	= autosave;
		/** @type {Array<{url:string,title?:string,titleJa?:string,titleEn?:string,categoryName?:string,categorySlug?:string,ts:number}>} */
		this.entries = [];
		this._loaded = false;
		this.load();
		// 初回描画（this.entriesを壊さない）
		this.updateList();
	}

	load() {
		try {
			const raw = localStorage.getItem(this.storageKey);
			if (raw) this.entries = Array.isArray(JSON.parse(raw)) ? JSON.parse(raw) : [];
			this._loaded = true;
		} catch (e) {
			console.warn('[VisitLog] load failed', e);
			this.entries = [];
		}
	}

	save() {
		if (!this.autosave) return;
		try {
			localStorage.setItem(this.storageKey, JSON.stringify(this.entries));
		} catch (e) {
			console.warn('[VisitLog] save failed', e);
		}
	}

	clear() {
		this.entries = [];
		this.save();
		this.updateList();
	}

	/**
	* 追加。categoryName/Slug のどちらかでも欠けていたら追加しない。
	* 競合に強くするため毎回 load() → push → save。
	*/
	add({ url, title, ts = Date.now(), categoryName, categorySlug, titleJa, titleEn, color, productTitle }) {
		if (!url) return;
		//console.log("categoryName:", categoryName, "categorySlug:", categorySlug);
		if (!categoryName || !categorySlug) return; // 条件：両方必須
		
		// 競合対策：常に最新を読み直してからpush
		this.load();
		
		this.entries.push({ url, title, titleJa, titleEn, categoryName, categorySlug, color, ts, productTitle });
		this.save();
		this.updateList();
	}

	/** URLに一致する最初のエントリを削除（先頭落とし時に使う） */
	removeFirstByUrl(url) {
		const idx = this.entries.findIndex(e => e.url === url);
		if( this.backDelete ){
			if (idx >= 0) {
				this.entries.splice(idx, 1);
				this.save();
				this.updateList();
			}
		}
	}
	
	/** 末尾（最新）を1件ポップ */
	popLast() {
		//console.log("pop last")
		const v = this.entries.pop();
		this.save();
		this.updateList();
		return v;
	}

	last() { return this.entries[this.entries.length - 1] ?? null; }
	all()  { return [...this.entries]; }

	/**
	* 描画専用。this.entries を上書きしない！
	* 最新のlocalStorageを参照したいときは「ローカル変数」に入れて使う。
	*/
	updateList() {
		const $list = document.querySelector('.c-list_log ul');
		if (!$list) return;

		let entries = this.entries;
		try {
			const raw = localStorage.getItem(this.storageKey);
			if (raw) {
				const parsed = JSON.parse(raw);
				if (Array.isArray(parsed)) entries = parsed; // ← this.entries に代入しない
			}
		} catch (e) {
			console.warn('[VisitLog] updateList read failed', e);
		}

		// 表示
		let html = '';
		let len = entries.length;
		let logMax = 20;
		for( let i = 0; i < logMax; i++){
			let entry = entries[ entries.length - i - 1];
			if( entry ){
				//console.log(entry);
				if( entry.url.includes("/products/") ){
					html += `<li>
						<a href="${entry.url}">
							<span class="ja">${entry.productTitle} ${entry.titleJa ?? ''}</span>
							<span class="en">${entry.titleEn ?? ''}</span>
						</a>
					</li>`
				}else{
					html += `<li>
								<a href="${entry.url}">
									<span class="ja">${entry.titleJa ?? ''}</span>
									<span class="en">${entry.titleEn ?? ''}</span>
								</a>
							</li>`;
				}
				
			}
		}
		$list.innerHTML = html;
		requestAnimationFrame(() => {
			let logContainer = document.querySelector("#s-log .s-inner");
			logContainer.scrollTop = "0px";
		});
	}
}

export const visitLog = new VisitLog();
export default visitLog;

/* 使い方
import { visitLog } from './_log.js';

// すべて取得（新しい順にしたい場合は .reverse() など）
console.table(visitLog.all());

// 最後の1件
console.log(visitLog.last());

// クリア
// visitLog.clear();
*/